import { onMounted, onUnmounted, reactive, toRefs } from 'vue'

export function useMonitorSize() {
  const sizes = reactive({
    isDesktop: true
  })

  let resizeTimeout: ReturnType<typeof setTimeout> | null = null

  const isDesktop = () => {
    return window.innerWidth >= 768
  }

  const browserResized = () => {
    sizes.isDesktop = isDesktop()
  }

  const debouncedResize = () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout)
    }
    resizeTimeout = setTimeout(() => {
      browserResized()
    }, 200)
  }

  onMounted(() => {
    sizes.isDesktop = isDesktop()
    window.addEventListener('resize', debouncedResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', debouncedResize)
  })

  return {
    ...toRefs(sizes)
  }
}
